import { mapFields } from './map-input-fields.js';

export const getEditorContent = (createmode, removeBorder, removeMargin) => {
	if (removeBorder) {
		const htmlData = mapFields(createmode, removeBorder, false, removeMargin);
		return htmlData;
	}

	const htmlData = mapFields(createmode);
	return htmlData;
};
